module.exports = __webpack_public_path__ + "img/Volders.9cf880bf.jpg";